<template>
  <v-dialog
    v-model="enable"
    max-width="320"
    persistent
    class="main--text"
    >
    <v-card>
      <v-container>
        <v-row
          justify=center>
          <v-col
            cols=auto>
            <h3>登録が完了しました！</h3>
          </v-col>
        </v-row>
        <v-row
          justify=center>
          <v-col
            cols=auto>
            <v-btn
              rounded
              depressed
              outlined
              color=primary
              @click="$emit('students-button-click')">お子さま一覧へ</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>


<script>
export default {
  props: {
    enable: {
      type: Boolean,
      default: false,
      required: true
    }
  }
}
</script>
